export const menuMobileData = ({ t }) => {
  return [
    {
      exact: true,
      to: '/who-we-are',
      labelLink: t('menu.who-we-are'),
    },
    {
      exact: false,
      to: '/applications',
      labelLink: t('menu.applications'),
    },
    {
      exact: false,
      to: '/products',
      labelLink: t('menu.products'),
    },
    {
      exact: false,
      to: '/news',
      labelLink: t('menu.news'),
    },
    {
      exact: false,
      to: '/contacts',
      labelLink: t('menu.contacts'),
    },
  ];
};
